import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export enum AuthStatus {
    Checking,
    Authenticated,
    Anonymous
}

// The session token lives in an HttpOnly cookie, so the portal only tracks who is logged in
interface AuthState {
    status: AuthStatus,
    login: string
}

// Only a "had a session" hint, never the token. Without it there is nothing to check, so the
// protected routes send the user to the login page right away instead of waiting for the API
export const SESSION_HINT_KEY = 'hasSession';

const hasSessionHint = () => {
    try {
        return localStorage.getItem(SESSION_HINT_KEY) !== null;
    }
    catch {
        return true;
    }
}

const initialState: AuthState = {
    status: hasSessionHint() ? AuthStatus.Checking : AuthStatus.Anonymous,
    login: ''
}

export const AuthSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        authenticate: (state, action: PayloadAction<string>) => {
            state.status = AuthStatus.Authenticated
            state.login = action.payload
        },
        unauthenticate: state => { 
            state.status = AuthStatus.Anonymous
            state.login = ''
        }
    }
})

export const { authenticate, unauthenticate } = AuthSlice.actions

export const selectAuthStatus = (state: RootState) => state.auth.status;
export const selectLogin = (state: RootState) => state.auth.login;

export default AuthSlice.reducer
